export enum EGeofenceSlotType {
    CIRCLE = 'circle',
    RECTANGLE = 'rectangle',
    POLYGON = 'polygon',
    KML = 'kml',
    ANY = 'any'
}

export function getGeofenceSlotTypeLabel(slotType: EGeofenceSlotType): string {
    switch (slotType) {
        case EGeofenceSlotType.KML:
            return 'KML';
        case EGeofenceSlotType.CIRCLE:
            return 'Circle';
        case EGeofenceSlotType.RECTANGLE:
            return 'Rectangle';
        case EGeofenceSlotType.POLYGON:
            return 'Polygon';
        default:
        case EGeofenceSlotType.ANY:
            return 'Any';
    }
}

export function getGeofenceSlotTypeFromString(slotTypeName: string): EGeofenceSlotType {
    switch (slotTypeName.toLowerCase()) {
        case 'kml':
            return EGeofenceSlotType.KML;
        case 'circle':
            return EGeofenceSlotType.CIRCLE;
        case 'rectangle':
            return EGeofenceSlotType.RECTANGLE;
        case 'polygon':
            return EGeofenceSlotType.POLYGON;
        case 'any':
        default:
            return EGeofenceSlotType.ANY;
    }
}
